const capitalize = (value) => {
  if (value == null || value == undefined) { return ""; }
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export default capitalize;